import axios from '@/utils/axios';

// Types

// API

export default {
	async getMonthScheduledEntries(month: number, year: number): Promise<any[]> {
		return (await axios().get(`/subscriptions/?month=${month}&year=${year}`)).data;
	},
};
